module.exports = __webpack_public_path__ + "media/images/add-ca835dace8fedc8495cd268bd0aca358.svg";